import { GeofencesImportPage, GeofencesRoute } from './-components';
import { createFileRoute, useRouter } from '@tanstack/react-router';

function GeofencesImportRoute() {
  const router = useRouter();

  return (
    <GeofencesRoute
      permission="journeys/geofences/create"
      redirectTo={(params) =>
        router.buildLocation({
          to: '/workspaces/$workspaceId/geofences',
          params: { workspaceId: params.workspaceId },
        }).href
      }
    >
      <GeofencesImportPage />
    </GeofencesRoute>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/geofences/import')({
  component: GeofencesImportRoute,
});
